var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox",on:{"click":_vm.toggleCheck}},[_c('div',{class:{
      inner: true,
      'is-checked': _vm.isChecked,
    }},[(_vm.isChecked)?_c('img',{attrs:{"src":require("../../assets/images/icons/selected.png"),"alt":""}}):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }